import styled from '@emotion/styled'
import type { TFunction } from 'i18next'

import type { Spacing } from '@cash-design-system/react'
import { spacing, Text } from '@cash-design-system/react'

type FontWeight = 500 | 600
type MarginBottom = Spacing | '0'
interface SupportSuperDuperMainTitleProps {
  fontWeight?: FontWeight
  marginBottom?: MarginBottom
  /** I18next translation function*/ t: TFunction
}

const SupportSuperDuperMainTitle = ({ fontWeight = 600, marginBottom = 'xl', t }: SupportSuperDuperMainTitleProps) => {
  const MainHeader = styled(Text)`
    font-weight: ${fontWeight}; /* stylelint-disable-line @cash-web/no-hardcoded-font-styles */
    margin-bottom: ${marginBottom === '0' ? '0' : spacing[marginBottom]};
  `
  return (
    <MainHeader typography="numeralSmall" as="h1" color="textStandard">
      {t('Support', { context: 'Support Home title' })}
    </MainHeader>
  )
}

export default SupportSuperDuperMainTitle
